export interface ICurrencyTop {
  rank: number | string
  name: string
  code: string
  lastPriceBtc: number | string
  chartData: any[] | string
  volume24h: number | string
  volume1h: number | string
  marketCap: number | string
  slug: string
  percentChange: number | string
  totalRecords: number | string
}

export class CurrencyTop implements ICurrencyTop {
  constructor(
    public rank: number | string = '',
    public name: string = '',
    public code: string = '',
    public lastPriceBtc: number | string = '',
    public chartData: any[] | string = '',
    public volume24h: number | string = '',
    public volume1h: number | string = '',
    public marketCap: number | string = '',
    public slug: string = '',
    public percentChange: number | string = '',
    public totalRecords: number | string = ''
  ) {}
}

export default CurrencyTop 